import { saveCountry as saveCountryService } from '../../../services/api/customer';
import { showHeaderSuccessFlashMessage } from '../flashMessage/actions';
import types from './types';

export const setCountry = ({ country }) => ({
    type: types.SET_COUNTRY,
    payload: { country }
});

export const saveCountry = ({ country, successMessage }) => async (dispatch) => {
    dispatch({ type: types.SAVE_COUNTRY.REQUEST });

    try {
        await saveCountryService({ country });
        dispatch({ type: types.SAVE_COUNTRY.SUCCESS, payload: { country } });
        dispatch(showHeaderSuccessFlashMessage(successMessage));
    }
    catch (e) {
        dispatch({ type: types.SAVE_COUNTRY.ERROR });
    }
};
